import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useCooldown(type) {
  const { token } = useUser();
  const [cooldown, setCooldown] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCooldown() {
      setLoading(true);
      const { response, data } = await API.fetchCooldown(token, type);

      if (response.ok) {
        setCooldown(data.remaining);
      }

      setLoading(false);
    }

    fetchCooldown();
  }, [type, token, setCooldown, setLoading]);

  return {
    loading,
    cooldown,
  };
}
